// TODO: Move getEvents to the Recording component
export default {
  pageLoad: async ({ getters, dispatch }) => {
    await dispatch('users/checkAuth');
    if (getters['users/loggedIn']) {
      dispatch('orgs/getOrgs', {}, { root: true });
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js